<template>
    <a :href="href" @click="$emit('click', $event)" class="k-tag">
        <slot></slot>
    </a>
</template>

<style lang="less" scoped>
.k-tag {
    display: inline-block;
    vertical-align: text-bottom;
    height: .33rem;
    border-radius: .165rem;
    overflow: hidden;
    background: #FAF4CD;
    color: #B0957A;
    font-size: .22rem;
    line-height: .33rem;
    padding: 0 .06rem;
    margin: 0 .07rem;
}
</style>

<script>
export default {
    name: 'k-tag',
    props: ['href']
}
</script>

